export default function Testimonials() {
  const testimonials = [
    {
      name: 'Emma Flores',
      date: '2 years ago',
      rating: 5,
      text: 'This is my first time using this company and they are immaculate, sufficient, reliable, caring, trustworthy and over amazing group of professionals that I am so glad I called. Will never use another moving company again. Highly recommending this company. 10 stars all the way! THANK YOU PALE AND GREW!',
      initial: 'E',
      color: 'bg-amber-100 text-amber-600',
    },
    {
      name: 'Velma Wright',
      date: '2 years ago',
      rating: 5,
      text: 'Words can\'t Describe how good this moving company was! WOW! Above and beyond service with such kind smiles! These guys were so hard working and so nice and polite and took joy in helping others out. Thank you so much City to City Moving Company!!! I will be calling again and referring everyone to you!',
      initial: 'V',
      color: 'bg-sky-100 text-sky-600',
    },
    {
      name: 'Angie Garcia',
      date: '2 years ago',
      rating: 5,
      text: 'I was in a bind — I needed help getting a freezer from Costco and a City to City truck happened to be nearby. The gentleman was so polite and willing to help. He followed me home, brought it inside, helped me install it, and even took the cardboard away. The fee was minimum compared to prices out there. I\'ve needed this company on a few other occasions and they always came through. Thank you Pele for all your help… This company is so amazing.',
      initial: 'A',
      color: 'bg-emerald-100 text-emerald-600',
    },
    {
      name: 'Nicole Roberts',
      date: '3 years ago',
      rating: 5,
      text: 'They helped me move everything I needed. It was my first time moving and I was extremely nervous as I had a lot to bring with me — a bed, dining table, large desk, couch and chairs. Everything was moved safely and was extremely easy. Nothing got damaged and they were incredibly friendly the entire time. I have no worries about moving in the future because I know I can always contact them!',
      initial: 'N',
      color: 'bg-violet-100 text-violet-600',
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-slate-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-sky-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header - Asymmetrical */}
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-bold mb-4">
              <i className="ri-star-fill mr-2"></i>Customer Stories
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
              Real Moves,<br />Real Reviews
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Our neighbors trust us with their most important belongings. Here's what they have to say about moving with City to City.
            </p>
          </div>

          {/* Rating Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100">
            <div className="flex items-center gap-4 mb-4">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`${i < 4 ? 'ri-star-fill' : 'ri-star-half-fill'} text-amber-400 text-3xl`}></i>
                ))}
              </div>
              <div className="text-5xl font-bold text-slate-900">4.6</div>
            </div>
            <div className="text-slate-600 text-lg">
              Based on <strong className="text-slate-900">10 verified Google reviews</strong> from local families and businesses
            </div>
            <div className="flex gap-3 mt-6">
              <div className="flex items-center gap-2 text-sm text-slate-600">
                <i className="ri-google-fill text-xl text-red-500"></i>
                Google Reviews
              </div>
            </div>
          </div>
        </div>

        {/* Masonry Layout Testimonials */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Column 1 */}
          <div className="space-y-6">
            <TestimonialCard testimonial={testimonials[0]} />
            <TestimonialCard testimonial={testimonials[3]} />
          </div>

          {/* Column 2 */}
          <div className="space-y-6 md:mt-12">
            <TestimonialCard testimonial={testimonials[1]} />
          </div>

          {/* Column 3 */}
          <div className="space-y-6 lg:mt-6">
            <TestimonialCard testimonial={testimonials[2]} />

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl p-8 text-white shadow-lg">
              <i className="ri-chat-smile-3-line text-5xl mb-4 opacity-90"></i>
              <h3 className="text-2xl font-bold mb-3">Join Our Happy Customers</h3>
              <p className="text-amber-50 mb-6 leading-relaxed">
                Experience the same stress-free moving service that earned us glowing 5-star reviews across Southern California.
              </p>
              <a
                href="#quote-form"
                className="inline-block bg-white text-amber-600 px-6 py-3 rounded-lg font-bold hover:bg-amber-50 transition-colors whitespace-nowrap w-full text-center"
              >
                Get Your Free Quote
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial }: { testimonial: any }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-slate-100">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-12 h-12 flex items-center justify-center ${testimonial.color} rounded-full font-bold text-lg`}>
            {testimonial.initial}
          </div>
          <div>
            <div className="font-bold text-slate-900">{testimonial.name}</div>
            <div className="text-sm text-slate-500">{testimonial.date}</div>
          </div>
        </div>
        <i className="ri-double-quotes-r text-3xl text-slate-200"></i>
      </div>

      {/* Rating */}
      <div className="flex gap-1 mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <i key={i} className="ri-star-fill text-amber-400 text-base"></i>
        ))}
      </div>

      {/* Review Text */}
      <p className="text-slate-700 leading-relaxed">
        {testimonial.text}
      </p>

      {/* Verified Badge */}
      <div className="flex items-center gap-2 mt-4 pt-4 border-t border-slate-100">
        <i className="ri-google-fill text-red-500"></i>
        <span className="text-sm text-slate-600">Google Review</span>
      </div>
    </div>
  );
}